module.exports = __webpack_public_path__ + "static/media/service-auto.cf9bf81b.png";